var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.00192C18.9288 1.2815 18.7477 1.48783 18.5554 1.69416C16.3597 4.05119 14.1715 6.41529 11.9699 8.76712C11.6216 9.13889 11.4582 9.53557 11.4649 10.0479C11.4859 11.6677 11.4679 13.2879 11.4761 14.9077C11.478 15.2865 11.3671 15.6051 11.1163 15.8888C10.2743 16.842 9.43755 17.8001 8.59894 18.7566C8.4145 18.967 8.1922 19.057 7.91553 18.9626C7.66961 18.8786 7.52791 18.6711 7.51704 18.373C7.51066 18.2001 7.51554 18.0268 7.51554 17.8536C7.51554 15.2133 7.51066 12.5733 7.52041 9.93299C7.52191 9.49542 7.37383 9.15079 7.07843 8.83441C4.81677 6.41157 2.56224 3.98205 0.305085 1.55512C-0.11778 1.10082 -0.10166 0.546504 0.357194 0.179194C0.455412 0.100378 0.583996 0.0587399 0.698335 0C6.56184 0 12.4253 0 18.2889 0C18.5145 0.0881099 18.7263 0.196295 18.847 0.418987C18.9037 0.523826 18.9494 0.634242 19 0.742056V1.00192V1.00192Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.d8793bf46edfd903b40b8dc47dec95db.svg";
export { ForwardRef as ReactComponent };